  import { useEffect, useState } from "react";
  import { useNavigate } from "react-router-dom";

  const API_BASE = process.env.REACT_APP_NAV_API;

  export default function PendingTaskCards({ onOpenLink }) {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

useEffect(() => {

  // ✅ Initial load
  load();

  // ✅ Auto refresh every 10 mins
  const interval = setInterval(() => {

    console.log("Refreshing pending summary...");

    load();

  }, 10 * 60 * 1000);

  return () => clearInterval(interval);

}, []);

    async function load() {
      try {
        setLoading(true);

        const res = await fetch(`${API_BASE}/pending/summary`, {
          credentials: "include"
        });

        const json = await res.json();
        if (json.ok) {
          setData(json.data || []);
        }

      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    }

    if (loading) return <div className="card">Loading Pending...</div>;

if (!data.length) {
  return (
    <div
      className="card"
      style={{ fontWeight: 700 }}
    >
      No Pending Tasks
    </div>
  );
}

return (
  <div className="card">
    
 <div
  className="cardTitle"
  style={{
    fontSize: "13px",
    fontWeight: "700"
  }}
>
  📌 Pending Tasks
</div>

    {data.map((dept, i) => (
      <div key={i} style={{ marginTop: 10 }}>

        {/* Department Header */}
        <div
          style={{
            fontWeight: 700,
            fontSize: "12px"
          }}
        >
          {dept.Department} ({dept.Total_Pending})
        </div>

        {/* Process Breakdown */}
        {dept.processList?.length > 0 && (
          <div style={{ marginTop: 6, paddingLeft: 10 }}>
            {dept.processList.map((p, idx) => (
              <div
                key={idx}
                onClick={() => {
                  if (!p.Link) return;

                  // Cloud Run services (Standard_Generic_Structure
                  // deployments) require their own Google login, which
                  // fails inside this app's iframe (403) — same rule
                  // as the sidebar tree, open in a new tab instead.
                  if (p.Link.includes(".run.app")) {
                    window.open(p.Link, "_blank");
                    return;
                  }

                  let path = p.Link;
                  try {
                    const u = new URL(p.Link);
                    path = u.pathname;
                  } catch (e) {
                    // raw path used as-is
                  }

                  navigate(path);
                }}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  cursor: "pointer",
                  fontSize: "12px",
                  padding: "2px 4px",
                  position: "relative",
                  zIndex: 9999,
                  pointerEvents: "auto",
                  background: "#fff"
                }}
              >
                <span>{p.processName}</span>

                <span
                  style={{
                    color: "#ef4444",
                    fontWeight: 700,
                    fontSize: "12px"
                  }}
                >
                  {p.pending}
                </span>
              </div>
            ))}
          </div>
        )}

      </div>
    ))}
  </div>
);
  }